export { default } from "./FormRegister";



// WEBPACK FOOTER //
// ./src/components/FormRegister/index.js